import * as React from 'react';
import {UiStore} from '../../stores/ui-store';
import {inject, observer} from 'mobx-react';
import './styles.css';
import {action, observable, runInAction} from 'mobx';
import {Link, RouteComponentProps} from 'react-router-dom';
import {AuthStore, UserGroup} from '../../stores/auth-store';
import {getClaimValue, msalInstance} from '../../utilities/msalConfig';

interface INavProps {
  uiStore?: UiStore;
  authStore?: AuthStore;
}

type Props = INavProps & RouteComponentProps<{}>;

interface INavLink {
  name: string;
  route?: string;
  userGroups?: UserGroup[];
  children?: INavLink[];
}

@inject('uiStore', 'authStore')
@observer
export class Nav extends React.Component<Props> {
  private uiStore?: UiStore;
  private authStore?: AuthStore;
  private links: INavLink[] = [
    { name: 'Sales', route: '/' },
    { name: 'Price Lists', route: '/price-lists' },
    { name: 'Customers', route: '/customers' },
    { name: 'Ranges', route: '/ranges', userGroups: [UserGroup.PricingManager] },
    { name: 'Suppliers', route: '/suppliers', userGroups: [UserGroup.PricingManager] },
    { name: 'Locations', route: '/locations', userGroups: [UserGroup.PricingManager] },
    { name: 'User', route: '/user' }, // previously Sales Rep
    { name: 'Reports', route: '/reports', userGroups: [UserGroup.PricingManager] },
    { name: 'Unleashed Sync', route: '/attacheSync', userGroups: [UserGroup.Administrator, UserGroup.PricingManager] },
    { name: 'Radaro Jobs', route: '/radaroJobs', userGroups: [UserGroup.MJDispatch] },
    {
      name: 'Monitors',
      userGroups: [UserGroup.Administrator],
      children: [
        { name: 'Purchase Orders', route: '/monitoring/purchase-orders' },
        { name: 'Order Totals', route: '/monitoring/order-totals' },
      ],
    },
    { name: 'Settings', route: '/settings', userGroups: [UserGroup.Administrator] },
  ];

  @observable private activeRoute: string;

  constructor(props: Props) {
    super(props);
    this.uiStore = props.uiStore;
    this.authStore = props.authStore;
    this.handleClose = this.handleClose.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
    runInAction(() => (this.activeRoute = this.props.location.pathname));
  }

  public render() {
    const repCode = getClaimValue('extn.repCode');
    return (
      <div className={'lg-nav ' + (this.uiStore!.navActive ? 'active' : '')} onClick={this.handleClose}>
        <div className="header-container">
          <h2>Mojoe</h2>
        </div>
        <div className="inner">
          <ul>
            {repCode &&
              this.links
                .filter((l) => {
                  if (!l.userGroups) return true;
                  return l.userGroups.some((userGroup) => this.authStore!.groupHasAccess(userGroup));
                })
                .map((l) => this.renderLink(l))}
            <li onClick={() => msalInstance.logoutRedirect()}>
              <Link to="">
                Logout
                <div className="username">{this.props.authStore!.userName}</div>
              </Link>
            </li>
          </ul>
        </div>
        <div className="logo-container">
          <img src={process.env.PUBLIC_URL + '/logo.png'} alt="ABC Building Products" />
        </div>
        <span className="version-tag">v{window.config.version}</span>
      </div>
    );
  }

  public handleClose() {
    this.uiStore!.setNavActive(false);
  }

  private renderLink(link: INavLink) {
    const isActive = this.activeRoute === link.route || link.children?.some((child) => child.route === this.activeRoute);

    if (link.children) {
      return (
        <li key={link.name} className={'nav-group ' + (isActive ? 'active' : '')}>
          <span className="nav-group-label">{link.name}</span>
          <ul>
            {link.children.map((child) => this.renderLink(child))}
          </ul>
        </li>
      );
    }

    return (
      <li
        key={link.name}
        className={isActive ? 'active' : ''}
        onClick={() => {
          this.handleSelection(link.route!);
        }}
      >
        <Link to={link.route!}>{link.name}</Link>
      </li>
    );
  }

  @action
  public handleSelection(link: string) {
    this.activeRoute = link;
  }
}
